/**
 * App config from Vite env (.env, .env.production, .env.mobile).
 * VITE_* vars are exposed at build time; empty API URL = same-origin + dev proxy.
 */
import { Capacitor } from '@capacitor/core';

const e = import.meta.env;

const PRODUCTION_API = 'https://repatikosam.com';

function resolveApiUrl() {
  const fromEnv = (e.VITE_API_URL ?? e.REACT_APP_API_URL ?? '').replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (import.meta.env.PROD && Capacitor.isNativePlatform()) {
    return PRODUCTION_API;
  }
  return '';
}

export const API_URL = resolveApiUrl();
export const SITE_URL = (e.VITE_SITE_URL ?? e.REACT_APP_SITE_URL ?? PRODUCTION_API).replace(/\/$/, '');

export function mediaUrl(path) {
  if (!path) return '';
  let raw = String(path).trim();
  if (/^\/\//.test(raw)) raw = `https:${raw}`;
  if (/^(https?:|data:|blob:)/i.test(raw)) {
    if (Capacitor.isNativePlatform()) {
      try {
        const u = new URL(raw);
        if (u.hostname === 'localhost' || u.hostname === '127.0.0.1') {
          return `${PRODUCTION_API}${u.pathname}${u.search}`;
        }
      } catch {
        /* keep original */
      }
    }
    return raw;
  }
  const p = raw.startsWith('/') ? raw : `/${raw}`;
  const base = API_URL || (Capacitor.isNativePlatform() ? PRODUCTION_API : '');
  return base ? `${base}${p}` : p;
}
export const GOOGLE_CLIENT_ID = e.VITE_GOOGLE_CLIENT_ID ?? e.REACT_APP_GOOGLE_CLIENT_ID ?? '';
/** Public Razorpay Key ID only — secret stays on server */
export const RAZORPAY_KEY_ID =
  e.VITE_RAZORPAY_KEY_ID ?? e.REACT_APP_RAZORPAY_KEY_ID ?? '';
/** Google Analytics 4 — optional, e.g. G-XXXXXXXXXX */
export const GA_MEASUREMENT_ID =
  e.VITE_GA_MEASUREMENT_ID ?? e.REACT_APP_GA_MEASUREMENT_ID ?? 'G-9YZ9RLGNJL';
/** Google Ads — optional, e.g. AW-XXXXXXXXX */
export const GOOGLE_ADS_ID =
  e.VITE_GOOGLE_ADS_ID ?? e.REACT_APP_GOOGLE_ADS_ID ?? 'AW-934528836';
/** Meta (Facebook) Pixel — optional */
export const META_PIXEL_ID =
  e.VITE_META_PIXEL_ID ?? e.REACT_APP_META_PIXEL_ID ?? '831760166378619';
export const WHATSAPP_CHANNEL_URL =
  e.VITE_WHATSAPP_CHANNEL_URL ?? e.REACT_APP_WHATSAPP_CHANNEL_URL ?? '';
